import { useGetShopConfig } from '../../services/core/settings';
import { getTaxDecimalPrecision } from '../helpers/taxCalculation';

/**
 * Allowed decimal places for tax percentages, from shop config (default 2).
 * Reads the shared (react-query cached) shop config, so calling it from multiple
 * components does not trigger extra requests.
 */
export const useTaxDecimalPrecision = () => {
    const { data } = useGetShopConfig();
    return getTaxDecimalPrecision(data);
};
